module.exports = __webpack_public_path__ + "img/powered.624780f2.png";